import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import styled from 'styled-components';

import { translation } from 'utils/translation';

import Flex from 'components/util/Flex';

import { PATH } from 'routers/paths';

type FooterProps = {
  isDesktop: boolean;
};
export default function Footer({ isDesktop }: FooterProps) {
  return (
    <SFooterWrapper>
      <Flex
        justify="center"
        align="center"
        direction={isDesktop ? 'row' : 'column-reverse'}
        rowGap={isDesktop ? 0 : 4}
        columnGap={isDesktop ? 30 : 0}
      >
        <p className="sub-text">{translation('footer.rights_message')}</p>
        <Flex justify="space-around" columnGap={isDesktop ? 18 : 10} flexWrap="wrap">
          <p className="sub-text">
            <Link target="_blank" to={PATH.POLICY.POLICY_REVENUE}>
              {/* 수익분배약관 */}
              {translation('chat.rewards_profit_sharing_terms')}
            </Link>
          </p>
          <p className="sub-text">
            <Link target="_blank" to={PATH.POLICY.POLICY_TERM}>
              {/* 이용약관 */}
              {translation('chat.rewards_terms_of_service')}
            </Link>
          </p>
          <p className="sub-text">
            <Link target="_blank" to={PATH.POLICY.POLICY_PRIVACY}>
              {/* 개인정보처리방침 */}
              {translation('chat.rewards_privacy_policy')}
            </Link>
          </p>
          <p className="sub-text">
            <Link target="_blank" to={PATH.POLICY.POLICY_REGULATION}>
              {/* 운영정책 */}
              {translation('chat.rewards_operational_policy')}
            </Link>
          </p>
          <p className="sub-text">
            <Link target="_blank" to={PATH.POLICY.POLICY_YOUTH}>
              {/* 청소년보호정책 */}
              {translation('chat.rewards_juvenile_protection_policy')}
            </Link>
          </p>
        </Flex>
      </Flex>
    </SFooterWrapper>
  );
}

const SFooterWrapper = styled.footer`
  /* margin-top: 40px; */
  padding: 13px 0;
  ${({ theme }) => theme.font.body3_r};

  @media ${({ theme }) => theme.device.large} {
    ${({ theme }) => theme.font.caption2_r};
    padding: 20px 0;
  }

  .sub-text {
    color: ${({ theme }) => theme.color.text.TXT_1};
  }

  .add-text {
    color: ${({ theme }) => theme.color.text.TXT_0};
  }
`;
